/**
 * How a member of staff is named to a pupil.
 *
 * The staff picker asked for `userName` first and fell back to a real name only when it was
 * missing, so "Who do you want to speak with?" listed whatever each account happened to have: a
 * login handle for some staff and a real name for others. A child choosing who to tell something
 * difficult to was shown "Mx EscalatorMGRS2" next to "Mx Abbas Khan" and had to work out which
 * adult that was.
 *
 * A name the pupil would recognise comes first; the handle is a last resort before "Unknown".
 * This mirrors StaffDisplayName in Custom-Api, which settles the same question for the staff side.
 */
export function staffDisplayName(staff) {
  const first = (staff?.firstName || '').trim();
  const last = (staff?.lastName || '').trim();

  if (first && last) return `${first} ${last}`;
  if (first) return first;
  if (last) return last;

  const userName = (staff?.userName || '').trim();
  if (userName) return userName;

  return 'Unknown';
}

/** The same name with the staff member's prefix, as the cards and the message header show it. */
export function staffDisplayNameWithPrefix(staff, separator = ' ') {
  const prefix = (staff?.prefix || 'Mx').trim() || 'Mx';
  return `${prefix}${separator}${staffDisplayName(staff)}`;
}
